import React, {useEffect, useState} from "react";
import {Button, Col, Collapse, Form, Modal, Pagination, Row, Space, Table, Tabs, Badge, Dropdown, Tooltip} from "antd";
import Input from "antd/es/input/Input";
import {useStore} from "../../store";
import styled from "styled-components";
import {ColumnsType} from "antd/lib/table";
import {DownOutlined, RedoOutlined, RightOutlined, SearchOutlined, UpOutlined} from "@ant-design/icons";
import {observer} from "mobx-react";
import {AtlasEntity} from "../../entity/atlas-entity";
import {transaction} from "mobx";
import DnaDetail from "./dna-detail";
import type {TabsProps} from 'antd';
import type {TableColumnsType} from 'antd';
import {render} from "react-dom";

const DnaList: React.FC = () => {

    const store = useStore();
    const [form] = Form.useForm();
    const {dnaLibraryStore} = store;
    const [tabKey, setTabKey] = useState('1')
    useEffect(() => {
        onQuery()
        return clear;
    }, [])

    const clear = () => {
        dnaLibraryStore.frontClear();
    }

    const onClose = () => {
        dnaLibraryStore.isFrontDetailOpen = false;
    }
    const onExpendClick = () => {
        const isExpend = dnaLibraryStore.isFrontExpend;
        dnaLibraryStore.isFrontExpend = !isExpend;
    }

    const columns: ColumnsType<AtlasEntity> = [
        // {
        //     title: '序列编号',
        //     width: 120,
        //     dataIndex: 'sequenceNumber',
        //     key: 'sequenceNumber',
        //     align: "center"
        // },
        // {
        //     title: '采样编号',
        //     width: 100,
        //     dataIndex: 'sampleNumber',
        //     key: 'sampleNumber',
        //     align: "center"
        // },
        {
            title: '药材名',
            dataIndex: 'medicineName',
            key: 'medicineName',
            align: "center"
        },
        {
            title: '基原植物',
            dataIndex: 'originalPlant',
            key: 'originalPlant',
            align: "center"
        },
        {
            title: '拉丁名',
            dataIndex: 'latinName',
            key: 'latinName',
            align: "center",
            ellipsis: {
                showTitle: false,
            },
            render: (text) => (
                <Tooltip placement="topLeft" title={text}>
                    {text}
                </Tooltip>
            ),
        },
        {
            title: '样品来源',
            dataIndex: 'sampleSource',
            key: 'sampleSource',
            align: "center"
        },
        // {
        //     title: '取样部位',
        //     width: 70,
        //     dataIndex: 'smapleLocation',
        //     key: 'smapleLocation',
        //     align: "center"
        // },
        {
            title: '样品提供单位',
            dataIndex: 'sampleUnit',
            key: 'sampleUnit',
            align: "center"
        },
        // {
        //     title: '序列类型',
        //     width: 150,
        //     dataIndex: 'sequenceType',
        //     key: 'sequenceType',
        //     align: "center"
        // },
        // {
        //     title: '序列提交时间',
        //     width: 150,
        //     dataIndex: 'sequenceTime',
        //     key: 'sequenceTime',
        //     align: "center"
        // }
    ];

    const onItemClick = (record: AtlasEntity) => {
        transaction(() => {
            dnaLibraryStore.isFrontDetailOpen = true
            dnaLibraryStore.frontDetailEntity = record
        })
    }

    const onSizeChange = (page: number, pageSize: number) => {
        transaction(() => {
            dnaLibraryStore.frontPagination.pageNum = page;
            dnaLibraryStore.frontPagination.pageSize = pageSize
            dnaLibraryStore.frontCondition.pageNum = page;
            dnaLibraryStore.frontCondition.pageSize = pageSize
            onQuery()
        })
    }

    const onQuery = () => {
        dnaLibraryStore.getDnaList(dnaLibraryStore.frontCondition)
    }

    const onReset = () => {
        dnaLibraryStore.onFrontReset()
        form.setFieldsValue(dnaLibraryStore.frontCondition)
        onQuery()
    }

    const FirstLevelSearch = () => {
        return (
            <Form form={form} labelAlign={"right"} style={{maxWidth: "none", padding: "5px"}} wrapperCol={{span: "15"}}><Row>
                <Col span={6} offset={1}><Form.Item name={"sequenceNumber"} labelCol={{span: "7"}}
                                                    label={"序列编号"}><Input
                    onChange={(e) => dnaLibraryStore.frontCondition.sequenceNumber = e.target.value}
                    value={dnaLibraryStore.frontCondition.sequenceNumber}/></Form.Item></Col>
                <Col span={6} offset={1}><Form.Item name={"sampleNumber"} labelCol={{span: "7"}}
                                                    label={"采样编号"}><Input
                    onChange={(e) => dnaLibraryStore.frontCondition.sampleNumber = e.target.value}
                    value={dnaLibraryStore.frontCondition.sampleNumber}/></Form.Item></Col>
                <Col span={6} offset={1}><Form.Item name={"medicineName"} labelCol={{span: "7"}} label={"药材名"}><Input
                    onChange={(e) => dnaLibraryStore.frontCondition.medicineName = e.target.value}
                    value={dnaLibraryStore.frontCondition.medicineName}/></Form.Item></Col>
                <Col span={3}><Button onClick={onExpendClick}
                                      icon={dnaLibraryStore.isFrontDetailOpen ? <UpOutlined/> : <DownOutlined/>}
                                      type={"link"}>{dnaLibraryStore.isFrontExpend ? "折叠" : "展开"}</Button></Col>
            </Row></Form>)
    }

    const SecondLevelSearch = () => {
        return (<Form form={form} labelAlign={"right"} style={{maxWidth: "none"}} wrapperCol={{span: "15"}}><Row>
            <Col span={6} offset={1}><Form.Item name={"originalPlant"} labelCol={{span: "7"}} label={"基原植物"}><Input
                onChange={(e) => dnaLibraryStore.frontCondition.originalPlant = e.target.value}
                value={dnaLibraryStore.frontCondition.originalPlant}/></Form.Item></Col>
            <Col span={6} offset={1}><Form.Item name={"latinName"} labelCol={{span: "7"}} label={"拉丁名 "}><Input
                onChange={(e) => dnaLibraryStore.frontCondition.latinName = e.target.value}
                value={dnaLibraryStore.frontCondition.latinName}/></Form.Item></Col>
            <Col span={6} offset={1}/>
            <Col span={3}/>
        </Row></Form>)
    }

    const onChangeTab = (key: string) => {
        setTabKey(key)
    }

    const expandedRowRender = (record: any) => {
        let items: TabsProps['items'] = [];
        record.tabList.forEach((element: AtlasEntity, index: any) => {
            items?.push({
                key: index + '',
                label: element.sequenceType
            })
        })
        const iColumns: TableColumnsType<AtlasEntity> = [
            {title: '序列标号', dataIndex: 'sequenceNumber', key: 'sequenceNumber', align: "center"},
            {title: '采样编号', dataIndex: 'sampleNumber', key: 'sampleNumber', align: "center"},
            {title: '序列提交时间', dataIndex: 'createtime', key: 'createtime', align: "center"},
            {title: '鉴定人', dataIndex: 'appraiser', key: 'appraiser', align: "center"},
            {title: '责任人', dataIndex: 'dutyPerson', key: 'dutyPerson', align: "center"},
            {title: '取样部位', dataIndex: 'smapleLocation', key: 'smapleLocation', align: "center"}
        ];
        return (
            <SecondLevelWrapper style={{margin: "15px 15px 15px 52px"}}>
                <Table
                    rowKey={record}
                    caption={<Tabs tabBarGutter={15} tabBarStyle={{marginBottom: "10px", height: "35px"}} style={{paddingLeft: "10px"}} defaultActiveKey={tabKey} items={items}
                                   onChange={onChangeTab}/>}
                    rowClassName={(type, index, intent) => {
                        return index % 2 === 0 ? "tableItemWhite" : "tableItemGray";
                    }}
                    onRow={(record) => {
                        return {
                            onClick: () => onItemClick(record),
                        }
                    }}
                    size={'small'}
                    bordered={true}
                    columns={iColumns}
                    dataSource={record.tabList[`${Number(tabKey)}`].tabList}
                    pagination={false}/>
            </SecondLevelWrapper>
        )
    }

    return (
        <Wrapper>
            <SearchWrapper>
                <SearchTitleWrapper>
                    <div className={"searchTitle"}>查询区域</div>
                    <Space className={"searchButton"} size={"small"} align={"start"} direction={"horizontal"}>
                        <Button onClick={onQuery} icon={<SearchOutlined/>} type={"primary"}>查询</Button>
                        <Button onClick={onReset} icon={<RedoOutlined/>} ghost={true} type={"primary"}>重置</Button>
                    </Space>
                </SearchTitleWrapper>
                <Line/>
                <Collapse
                    activeKey={dnaLibraryStore.isFrontExpend ? ['1'] : ["0"]}
                    defaultActiveKey={['0']} ghost>
                    <Collapse.Panel collapsible={"icon"} showArrow={false} key={1} header={<FirstLevelSearch/>}>
                        <SecondLevelSearch/>
                    </Collapse.Panel>
                </Collapse>
            </SearchWrapper>
            <ContentWrapper>
                <Table
                    style={{margin: "20px 20px 5px 20px"}}
                    rowClassName={(type, index, intent) => {
                        return index % 2 === 0 ? "tableItemWhite" : "tableItemGray";
                    }}
                    rowKey={record => {
                        return record.originalPlant
                    }}
                    bordered={true}
                    columns={columns}
                    expandable={{
                        columnWidth: 100,
                        expandedRowRender,
                        expandIcon: ({ expanded, onExpand, record }) =>
                            !expanded ? (<DownOutlined onClick={e => onExpand(record, e)}/>)
                                : (<UpOutlined onClick={e => onExpand(record, e)} />),
                        defaultExpandedRowKeys: [''],
                    }}
                    scroll={{x: 1000, y: 400}}
                    pagination={false}
                    dataSource={dnaLibraryStore.frontDataSource}
                    size={"middle"}
                />
                <Pagination
                    total={dnaLibraryStore.frontPagination.total}
                    size={"small"}
                    style={{margin: "0px 20px 20px 0", alignSelf: "end"}}
                    showQuickJumper={true}
                    showSizeChanger={true}
                    defaultPageSize={10}
                    hideOnSinglePage={true}
                    onChange={onSizeChange}
                    current={dnaLibraryStore.frontPagination.pageNum}
                />
            </ContentWrapper>
            <Modal
                open={dnaLibraryStore.isFrontDetailOpen}
                onCancel={onClose}
                closable={true}
                centered={true}
                destroyOnClose={true}
                footer={null}
                mask={true}
                maskClosable={true}
                width={"1200px"}>
                <DnaDetail detail={dnaLibraryStore.frontDetailEntity}/>
            </Modal>
        </Wrapper>
    );
}

export default observer(DnaList);

const Wrapper = styled.div`
  & {
    display: flex;
    flex-direction: column;
    height: 100%;
    background: #EDEFEF;
    padding: 15px 20px;
    overflow: hidden;

    .tableItemWhite {
      background: white;
    }

    .tableItemGray {
      background: #F9FAFD;
    }

    .ant-form-item {
      margin-bottom: 0px;
    }

  }
`;
const SearchWrapper = styled.div`
  & {
    border-radius: 4px;
    border: 1px solid #EAEDF7;
    background: white;
    display: flex;
    flex-direction: column;
    padding-bottom: 10px;
  }
`;
const SearchTitleWrapper = styled.div`
  & {
    display: flex;
    justify-content: space-between;
    margin: 15px 20px 13px 20px;

    .searchTitle {
      font-size: 16px;
      font-family: SourceHanSansCN-Medium, SourceHanSansCN;
      font-weight: 500;
      color: #000000;
      line-height: 32px;
      flex: 1;
    }
  }
`;

const Line = styled.div`
  & {
    height: 0.5px;
    border: 1px solid #EAEDF7;
  }
`;
const ContentWrapper = styled.div`
  & {
    flex: 1;
    margin-top: 20px;
    border-radius: 4px;
    border: 1px solid #EAEDF7;
    background: white;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
`;
const SecondLevelWrapper = styled.div`
  & {
    .ant-table-wrapper .ant-table-thead >tr>th,
    .ant-table-wrapper .ant-table-thead >tr>td {
      background: #eeeeee;
      font-size: 12px;
      color: #444444;
      font-weight: 600;
      padding: 4px 4px;
    }
    .ant-table-wrapper .ant-table-container table>thead>tr:first-child >*:first-child {
      border-radius: 0px;
    }
    .ant-table-wrapper .ant-table-container table>thead>tr:first-child >*:last-child {
      border-radius: 0px;
    }
    .ant-table-wrapper table {
      border-radius: 0;
    }
  }
`;